module.exports = __webpack_public_path__ + "static/media/auger2.9924d419.png";